import api from "../../../services/api"
import { IGetHospitalsResponse } from "./types";

export const getHospitals = async (signal: AbortSignal) => (await api.get<IGetHospitalsResponse[]>('new/hospitals/list', { signal })).data;
export const registerChangeHospitalLog = async (uuid: string) => await api.put(`/user/hospital/${uuid}`);